import styled from 'styled-components';

const FrameHeaderStyled = styled.div(({ theme }) => ({
  position: 'fixed',
  width: '100%',
  height: theme.space[8], // use from spaces variable
  background: theme.color.wfBlack,
  // TODO use it from theme
  zIndex: 999999,
}));

const FrameHeaderTitle = styled.span(({ theme }) => ({
  color: theme.color.wfWhite,
  fontSize: theme.font.size.xsmall,
}));

export { FrameHeaderStyled, FrameHeaderTitle };
